module.exports = __webpack_public_path__ + "img/home-bg6-3.3c05e540.png";